"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Cloud: function() {
        return Cloud;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Cloud = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 6C9.51785 6 7.45643 7.80967 7.0665 10.1816C6.99268 10.6306 6.62505 10.9731 6.17196 11.0151C4.39329 11.1798 3 12.6778 3 14.5C3 16.433 4.567 18 6.5 18H18.5C19.8807 18 21 16.8807 21 15.5C21 14.1193 19.8807 13 18.5 13C18.3549 13 18.2134 13.0123 18.0763 13.0356C17.7556 13.0902 17.4285 12.9854 17.1992 12.7547C16.9699 12.5241 16.8672 12.1963 16.9237 11.876C16.9738 11.5922 17 11.2996 17 11C17 8.23858 14.7614 6 12 6ZM5.24923 9.14303C6.0632 6.17816 8.7764 4 12 4C15.866 4 19 7.13401 19 11C19 11.0092 19 11.0183 18.9999 11.0275C21.2499 11.2762 23 13.1837 23 15.5C23 17.9853 20.9853 20 18.5 20H6.5C3.46243 20 1 17.5376 1 14.5C1 11.8925 2.8139 9.70961 5.24923 9.14303Z",
        fill: "currentColor"
    })
}), "Cloud");
const _default = Cloud;
